import { PositionNum, PositionStr } from 'map/types/position';
import { moveCamera } from './camera';
import { drawMarker } from './marker';

// 위치확인
export const showLocation = async (floorId: string, position: PositionStr | PositionNum) => {
  await drawMarker(floorId, position);

  moveCamera(position);
};
